import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CloneTemplateRequest, CloneTemplateResponse, CreateOrUpdateTemplatesRequest, CreateOrUpdateTemplatesResponse, DeleteBrandRequest, DeleteBrandResponse, DeleteTemplateRequest, DeleteTemplateResponse, DeleteTemplateSectionRequest, DeleteTemplateSectionResponse, GetProfileBrandsRequest, GetProfileBrandsResponse, GetWebpageConfigurationDetailRequest, GetWebpageConfigurationDetailResponse, RefineContentPromptRequest, RefineContentPromptResponse, RenameTemplateRequest, RenameTemplateResponse, SaveProfileBrandsRequest, SaveProfileBrandsResponse, UpdateProfileBrandRequest, UpdateProfileBrandResponse, WebpageTemplateRequest, WebpageTemplateResponse } from 'src/app/_shared/models/webpage-template.model';
import { StorageHelper } from 'src/app/_utilities/storage-helper';
@Injectable({
  providedIn: 'root',
})
export class WebpageTemplateService {
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    private _storageHelper: StorageHelper;
    constructor(
      private http: HttpClient,
      @Inject('BASE_URL') private baseUrl: string
    ) {
      this._storageHelper = new StorageHelper();
    }

    public getTemplates(request: WebpageTemplateRequest): Observable<WebpageTemplateResponse> {
      return this.http.post<WebpageTemplateResponse>(
            `${this.baseUrl}api/WebpageTemplate/getTemplates`,
            request,
            { headers: this.headers }
      );
    }

    public renameTemplate(request: RenameTemplateRequest): Observable<RenameTemplateResponse> {
      return this.http.post<RenameTemplateResponse>(
          `${this.baseUrl}api/WebpageTemplate/templates/rename`,
          request,
          { headers: this.headers }
      );
    }

    public cloneTemplate(request: CloneTemplateRequest): Observable<CloneTemplateResponse> {
      return this.http.post<CloneTemplateResponse>(
        `${this.baseUrl}api/WebpageTemplate/templates/clone`,
        request,
        { headers: this.headers }
      );
    }

    public deleteTemplate(request: DeleteTemplateRequest): Observable<DeleteTemplateResponse> {
      return this.http.post<DeleteTemplateResponse>(
        `${this.baseUrl}api/WebpageTemplate/templates/delete`,
        request,
        { headers: this.headers }
      );
    }

    public deleteTemplateSection(request: DeleteTemplateSectionRequest): Observable<DeleteTemplateSectionResponse> {
      return this.http.post<DeleteTemplateSectionResponse>(
        `${this.baseUrl}api/WebpageTemplate/templates/sections/delete`,
        request,
        { headers: this.headers }
      );
    }

    public CreateOrUpdateTemplates(request: CreateOrUpdateTemplatesRequest): Observable<CreateOrUpdateTemplatesResponse> {
      return this.http.post<CreateOrUpdateTemplatesResponse>(
        `${this.baseUrl}api/WebpageTemplate/templates`,
        request,
        { headers: this.headers }
      );
    }

    public RefineContentPrompt(request: RefineContentPromptRequest): Observable<RefineContentPromptResponse> {
      return this.http.post<RefineContentPromptResponse>(
        `${this.baseUrl}api/WebpageTemplate/refineContentPrompt`,
        request,
        { headers: this.headers }
      );
    }

    public GetWebpageConfigurationDetail(request: GetWebpageConfigurationDetailRequest): Observable<GetWebpageConfigurationDetailResponse> {
      return this.http.post<GetWebpageConfigurationDetailResponse>(
        `${this.baseUrl}api/WebpageTemplate/getWebpageConfigurationDetail`,
        request,
        { headers: this.headers }
      );
    }

    public GetProfileBrands(request: GetProfileBrandsRequest): Observable<GetProfileBrandsResponse> {
      return this.http.post<GetProfileBrandsResponse>(
        `${this.baseUrl}api/WebpageTemplate/getProfileBrands`,
        request,
        { headers: this.headers }
      );
    }

    public SaveProfileBrand(request: SaveProfileBrandsRequest): Observable<SaveProfileBrandsResponse> {
      return this.http.post<SaveProfileBrandsResponse>(
        `${this.baseUrl}api/WebpageTemplate/saveProfileBrand`,
        request,
        { headers: this.headers }
      );
    }

    public updateBrand(request: UpdateProfileBrandRequest): Observable<UpdateProfileBrandResponse> {
      return this.http.post<UpdateProfileBrandResponse>(
          `${this.baseUrl}api/WebpageTemplate/brands/update`,
          request,
          { headers: this.headers }
      );
    }

    public deleteBrand(request: DeleteBrandRequest): Observable<DeleteBrandResponse> {
      return this.http.post<DeleteBrandResponse>(
        `${this.baseUrl}api/WebpageTemplate/brands/delete`,
        request,
        { headers: this.headers }
      );
    }
}
